import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=3fd1c172&scoped=true&"
import script from "./volunteer.vue?vue&type=script&lang=js&"
export * from "./volunteer.vue?vue&type=script&lang=js&"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=3fd1c172&scoped=true&lang=less&"
import style1 from "./volunteer.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd1c172",
  null
  
)

export default component.exports